import React from 'react';
import { motion } from 'framer-motion';
import { Plus, MapPin } from 'lucide-react';
import { DataCenterIllustration } from '../illustrations/DataCenterIllustration';

interface EmptyLocationsProps {
  onAddLocation: () => void;
}

export function EmptyLocations({ onAddLocation }: EmptyLocationsProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="relative bg-white rounded-2xl shadow-sm border border-gray-200 p-8"
    >
      <div className="max-w-md mx-auto text-center">
        <div className="mb-6 relative">
          <DataCenterIllustration />
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          No locations added yet
        </h3>
        <p className="text-gray-600 mb-6">
          Add your first mining facility to start managing your operations
        </p>

        <button
          onClick={onAddLocation}
          className="inline-flex items-center gap-2 px-6 py-3 text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors group"
        >
          <Plus className="w-5 h-5 transition-transform group-hover:rotate-90" />
          <span className="font-medium">Add your first location</span>
        </button>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-6 left-6">
        <div className="w-20 h-20 bg-blue-50 rounded-full opacity-20 animate-pulse" />
      </div>
      <div className="absolute bottom-6 right-6">
        <div className="w-16 h-16 bg-purple-50 rounded-full opacity-20 animate-pulse" />
      </div>
    </motion.div>
  );
}